export default "__VITE_PUBLIC_ASSET__7a3dee80__"